import Model from "../../../../Model.js";

/**
 * `reportColumn` is a column is a report.  It contains a header.
 *
 * @param {string} [spec.header] - Header of the column
 */
export default class ReportColumn extends Model {
	constructor({ header }) {
		super(...arguments);
		this._header = header || "";
		this._report = null;
	}

	getHeader() {
		return this._header;
	}

	setReport(newReport) {
		this._report = newReport;
	}

	getValue(row) {
		return row.getValue(this);
	}

	accept(visitor) {
		return visitor.visitColumn(this);
	}
}
